<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import MerchPlannerIndex from '../components/tasks/MerchPlannerIndex.vue'
import TasksIndex from '../components/tasks/TasksIndex.vue'

//Translations
const { t } = useI18n({ useScope: 'global' })
const storeItemsLabel = (key: string) => t(`tables.${key}`)

//Tabs
const tab = ref('tasks')
</script>

<template>
  <q-page class="q-pt-sm">
    <q-tabs
      v-model="tab"
      class="text-grey"
      active-color="secondary"
      indicator-color="secondary"
      align="left"
      narrow-indicator
    >
      <q-tab name="tasks" :label="storeItemsLabel('tasks')" />
      <q-tab name="merchPlanner" :label="storeItemsLabel('merchPlanner')" />
    </q-tabs>
    <q-separator />
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel keep-alive name="tasks">
        <TasksIndex />
      </q-tab-panel>
      <q-tab-panel keep-alive name="merchPlanner">
        <MerchPlannerIndex />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>
